import React, { useState, useEffect } from "react";
import NumberFormat from "react-number-format";
import {
  faBoxes,
  faDownload,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IoIosArrowForward } from "react-icons/io";
import { Button, Form, Modal, Table } from "react-bootstrap";
import useReactRouter from "use-react-router";
import { IoMdAdd } from "react-icons/io";
import { useParams } from "react-router-dom";
import { useLazyQuery, useMutation } from "@apollo/client";
import { useToasts } from "react-toast-notifications";

import {
  GET_ORDERGROUPS_DETAIL,
  GET_ORDER_STOCK_AMOUNT,
} from "../../graphql/order/query";
import AnimationLoading from "../../components/AnimationLoading";
import { convertOrderStatus } from "../../helpers/orderStatus";
import moment from "moment";
import { imageRender, thousandSeperate } from "../../helpers";
import { COLOR_APP } from "../../constants";
import { GET_STOCKS } from "../../graphql/stock/query";
import {
  CREATE_LIVESTOCKS,
  CREATE_ORDER,
  DELETE_ORDER,
  UPDATE_ORDERGROUP,
  UPDATE_STOCK_AMOUNT,
} from "../../graphql/order/mutation";

//ToDo:
//Delete order from table
//1.Get id from order fatrash
//2.Delete id from order
//3.Update Stock Amount
//4.Delete id from orders in orderGroup

function OrderGroupDetail() {
  const { history } = useReactRouter();
  const [createOrder] = useMutation(CREATE_ORDER);
  const [updateStockAmount] = useMutation(UPDATE_STOCK_AMOUNT);
  const [createLiveStock] = useMutation(CREATE_LIVESTOCKS);
  const [getOrderData, { data: orderData }] = useLazyQuery(
    GET_ORDERGROUPS_DETAIL,
    { fetchPolicy: "cache-and-network" }
  );
  const [getStocks, { data: stockData }] = useLazyQuery(GET_STOCKS, {
    fetchPolicy: "cache-and-network",
  });
  const [getOrderStockAmount, { data: orderStockAmount }] = useLazyQuery(
    GET_ORDER_STOCK_AMOUNT,
    { fetchPolicy: "cache-and-network" }
  );
  const [updateOrderGroup] = useMutation(UPDATE_ORDERGROUP);
  const [deleteOrder] = useMutation(DELETE_ORDER);

  const [loading, setLoading] = useState(false);
  let { orderId } = useParams();
  const [orderList, setOrderList] = useState([]);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showOrder, setShowOrder] = useState(false);
  const [selectOrderIndex, setSelectOrderIndex] = useState();
  const [selectedOrderId, setSelectedOrderId] = useState();
  const [totalAll, setTotalAll] = useState();

  const [cfCode, setCfCode] = useState();
  const [stockId, setStockId] = useState();
  const [productName, setProductName] = useState();
  const [productId, setProductId] = useState();
  const [amount, setAmount] = useState(1);
  const [price, setPrice] = useState();
  const [totalPrice, setTotalPrice] = useState();
  const [stocksData, setStocksData] = useState([]);
  const [userConfirmId, setUserConfirmId] = useState();
  const [_orderId, setOrderId] = useState();
  const [stockAmount, setStockAmount] = useState();

  const [cfName, setCfName] = useState("");
  const [phone, setPhone] = useState("");
  const [logistic, setLogistic] = useState("");
  const [paySlip, setPaySlip] = useState("");
  const [note, setNote] = useState("");
  const [address, setAddress] = useState("");
  const [shipPrice, setShipPrice] = useState(0);
  const [paymentType, setPaymentType] = useState("");
  const [check, setCheck] = useState(true);
  const [orderType, setOrderType] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);

  let SHOP_ID = localStorage.getItem("SHOP");
  let LIVE_ID = localStorage.getItem("LIVE_ID");
  const { addToast } = useToasts();

  useEffect(() => {
    getOrderGroupDetail();
    getUserStock();
  }, []);

  useEffect(() => {
    if (paymentType == "DESTINATION") {
      setCheck(true);
    } else {
      setCheck(false);
    }
  }, [paymentType]);

  // useEffect(() => {
  //   if (check) {
  //     setPaymentType("DESTINATION")
  //   } else {
  //     setPaymentType("ORIGINAL")
  //   }
  // }, [check])

  useEffect(() => {
    getOrderGroupDetail();
    getUserStock();
  }, [orderId]);

  useEffect(() => {
    if (orderData) {
      setLoading(false);
      setOrderList(orderData?.orderGroup?.orders);
      setUserConfirmId(orderData?.orderGroup?.userConfirm?.id);
    }
  }, [orderData]);

  useEffect(() => {
    if (stockData?.stocks?.data?.length > 0) {
      setStocksData(stockData?.stocks?.data ?? []);
    }
  }, [stockData]);

  useEffect(() => {
    let _total = price * amount;
    setTotalPrice(_total);
  }, [price]);

  useEffect(() => {
    let _total = price * amount;
    setTotalPrice(_total);
  }, [amount]);

  useEffect(() => {
    if (_orderId) {
      let element = [];
      let newOrder = [...orderList];
      newOrder.push({ id: _orderId });
      for (let index = 0; index < newOrder.length; index++) {
        element.push(newOrder[index]?.id);
      }
      _updateOrderGroup(element);
    }
  }, [_orderId]);

  useEffect(() => {
    if (orderList) {
      let sum = 0;
      let qty = 0;
      for (let index = 0; index < orderList.length; index++) {
        sum = sum + orderList[index].totalPrice;
        qty = qty + orderList[index].amount;
      }
      setTotalAll(sum);
      setTotalAmount(qty);
    }
  }, [orderList]);

  const _updateOrderGroup = async (orderData) => {
    try {
      await updateOrderGroup({
        variables: {
          data: {
            orders: orderData,
          },
          where: {
            id: orderId,
          },
        },
      });
      getOrderGroupDetail();
      getUserStock();
    } catch (error) {
      console.log(error);
    }
  };

  const getUserStock = async () => {
    try {
      let SHOP_ID = await localStorage.getItem("SHOP");
      await getStocks({
        variables: {
          where: {
            isDeleted: false,
            shop: SHOP_ID,
          },
          orderBy: "createdAt_DESC",
          limit: 1000,
          skip: 0,
        },
      });
    } catch (error) {
      console.log("Error retrieving posts", error);
    }
  };

  const _getOrderStockAmount = async (id) => {
    // console.log("Myid: ", id)
    try {
      const _res = await getOrderStockAmount({
        variables: {
          where: {
            id: id,
          },
        },
      });
      if (_res?.data?.order?.liveStock?.stock?.id) {
        _updateStockAfterDelete(
          _res?.data?.order?.liveStock?.stock?.id,
          _res?.data?.order?.liveStock?.stock?.amount
        );
      }
    } catch (error) {
      console.log("getOrderStockAmount: ", error);
    }
  };

  const getOrderGroupDetail = async () => {
    try {
      setLoading(true);
      const _orderData = await getOrderData({
        variables: {
          orderBy: "createdAt_DESC",
          where: {
            id: orderId,
          },
        },
      });
      // console.log("_orderData: ", _orderData?.data?.orderGroup)
      setCfName(_orderData?.data?.orderGroup?.cfName);
      setPhone(_orderData?.data?.orderGroup?.phone);
      setLogistic(_orderData?.data?.orderGroup?.logistic);
      setPaySlip(_orderData?.data?.orderGroup?.paySlip);
      setAddress(_orderData?.data?.orderGroup?.addressCf);
      setNote(_orderData?.data?.orderGroup?.note);
      setShipPrice(_orderData?.data?.orderGroup?.shipPrice);
      setOrderType(_orderData?.data?.orderGroup?.type);
      setPaymentType(_orderData?.data?.orderGroup?.paymentType);
    } catch (error) {
      console.log("get order group error: ", error);
    }
  };

  const _updateStockAmount = async () => {
    try {
      let resAmount = parseInt(stockAmount) - parseInt(amount);
      if (resAmount > 0) {
        await updateStockAmount({
          variables: {
            data: {
              amount: resAmount,
            },
            where: {
              id: stockId,
            },
          },
        });
      }
    } catch (error) {
      console.log("_updateStockAmount Error: ", error);
    }
  };

  const _createLiveStock = async () => {
    try {
      const _res = await createLiveStock({
        variables: {
          data: {
            amount: parseInt(amount),
            amountAll: parseInt(amount),
            live: LIVE_ID,
            stock: stockId,
            shop: SHOP_ID,
            cfMessage: cfCode,
          },
        },
      });
      if (_res?.data?.createLiveStock?.id) {
        _createOrder(_res?.data?.createLiveStock?.id);
        _updateStockAmount();
      }
    } catch (error) {
      console.log("createLiveStock Error: ", error);
    }
  };

  const _createOrder = async (_liveStockId) => {
    try {
      let afterCreatedLiveStock = await createOrder({
        variables: {
          data: {
            shop: SHOP_ID,
            live: LIVE_ID,
            liveStock: _liveStockId,
            cfMessage: cfCode,
            cfName: orderData?.orderGroup?.cfName,
            productName,
            product: productId,
            phone: orderData?.orderGroup?.phone ?? "",
            price: parseInt(price),
            totalPrice: parseInt(totalPrice),
            userConfirm: userConfirmId,
            amount: parseInt(amount),
          },
        },
      });
      setOrderId(afterCreatedLiveStock?.data?.createOrder?.id);
    } catch (error) {
      console.log("afterCreatedLiveStock Error: ", error);
    }
  };

  const _createOrderKeyIn = async () => {
    try {
      let _res = await createOrder({
        variables: {
          data: {
            type: "KEY_IN",
            stock: stockId,
            amount: parseInt(amount) ?? 0,
            productName: productName ?? "",
            cfMessage: cfCode ?? "",
            price: parseInt(price) ?? 0,
            phone: orderData?.orderGroup?.phone ?? "",
            totalPrice: parseInt(totalPrice) ?? 0,
            cfName: orderData?.orderGroup?.cfName,
            shop: SHOP_ID,
          },
        },
      });
      if (_res?.data?.createOrder?.id) {
        setOrderId(_res?.data?.createOrder?.id);
        _updateStockAmount();
      }
    } catch (error) {
      console.log("createOrderKeyIn: ", error);
    }
  };

  const handleDelete = () => {
    if (orderData?.orderGroup?.type == "LIVE") {
      deleteOrderLive();
    } else if (orderData?.orderGroup?.type == "KEY_IN") {
      deleteOrderKeyIn();
    }
  };

  const deleteOrderKeyIn = async () => {
    try {
      setLoading(true);
      const _deleteOrder = await deleteOrder({
        variables: {
          where: {
            id: selectedOrderId,
          },
        },
      });
      if (_deleteOrder) {
        _getOrderStockAmountKeyIn(selectedOrderId);
        setShowDeleteConfirm(false);
      }
    } catch (error) {
      console.log("deleteOrderKeyInError: ", error);
      setShowDeleteConfirm(false);
    }
  };

  const _getOrderStockAmountKeyIn = async (id) => {
    try {
      const _res = await getOrderStockAmount({
        variables: {
          where: {
            id: id,
          },
        },
      });
      if (_res?.data?.order?.amount) {
        _updateStockAfterDelete(
          _res?.data?.order?.stock?.id,
          _res?.data?.order?.stock?.amount
        );
      }
    } catch (error) {
      console.log("getOrderStockAmountError: ", error);
    }
  };

  const deleteOrderLive = async () => {
    try {
      setLoading(true);
      const _deleteOrder = await deleteOrder({
        variables: {
          where: {
            id: selectedOrderId,
          },
        },
      });
      if (_deleteOrder) {
        _getOrderStockAmount(selectedOrderId);
        setShowDeleteConfirm(false);
      }
    } catch (error) {
      console.log("Delete Order Error: ", error);
      setShowDeleteConfirm(false);
    }
  };

  const _updateStockAfterDelete = async (_id, _amount) => {
    try {
      let resAmount = parseInt(_amount) + parseInt(amount);
      if (resAmount > 0) {
        const _res = await updateStockAmount({
          variables: {
            data: {
              amount: resAmount,
            },
            where: {
              id: _id,
            },
          },
        });
        if (_res?.data?.updateStock?.id) {
          let element = [];
          let newOrder = [...orderList];
          newOrder.pop({ id: selectedOrderId });
          for (let index = 0; index < newOrder.length; index++) {
            element.push(newOrder[index]?.id);
          }
          _updateOrderGroup(element);
        }
      }
    } catch (error) {
      console.log("_updateStockAfterDelete Error: ", error);
    }
  };

  const onSelectStock = async (e) => {
    const checkStock = stocksData.filter((stock) =>
      e?.target?.value.trim().split("ລະຫັດ: ")[0] != ""
        ? stock.cfMessage == e?.target?.value.trim().split("ລະຫັດ: ")[0]
        : stock.cfMessage == e?.target?.value.trim().split("ລະຫັດ: ")[1]
    );

    if (checkStock.length > 0) {
      setProductId(checkStock[0]?.product?.id);
      setCfCode(checkStock[0].cfMessage);
      setProductName(checkStock[0].name);
      setPrice(checkStock[0].price);
      setStockId(checkStock[0].id);
      setStockAmount(checkStock[0].amount);
    }
  };

  const _selectOrderIndex = (id, index, order) => {
    setShowDeleteConfirm(true);
    setSelectOrderIndex(index);
    setSelectedOrderId(id);
    setAmount(order?.amount);
  };

  const updateAllGroupField = async () => {
    try {
      const _res = await updateOrderGroup({
        variables: {
          data: {
            cfName,
            note,
            phone,
            addressCf: address,
            shipPrice: parseFloat(shipPrice),
            totalPrice: totalAll,
            paymentType: paymentType,
            amount: totalAmount,
          },
          where: {
            id: orderId,
          },
        },
      });
      addToast("ສ້າງອໍເດີ້ສຳເລັດ!", {
        appearance: "success",
        autoDismiss: true,
      });
      history.push(`/orders`);
    } catch (error) {
      console.log(error);
    }
  };

  //routes
  const _gotoOrder = () => {
    history.push(`/orders/limit/30/page/1`);
  };

  return (
    <div>
      {loading ? <AnimationLoading /> : <div />}
      <div style={{ height: 10 }}></div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <FontAwesomeIcon icon={faBoxes} />
        <div
          style={{
            color: "#9B51E0",
            cursor: "pointer",
            marginLeft: 5,
            marginTop: 5,
          }}
          onClick={() => _gotoOrder()}>
          ອໍເດີ້
        </div>
        <IoIosArrowForward style={{ marginTop: 5, marginLeft: 5 }} />
        <div style={{ marginLeft: 5, marginTop: 5 }}>ຈັດການອໍເດີ້</div>
      </div>
      <div style={{ height: 21 }} />
      {orderType == "LIVE" ? (
        <div style={{ width: "93vw" }}>
          <h4 style={{ fontWeight: "bold" }}>ສ້າງອໍເດີ້</h4>
          <div
            style={{ borderBottom: "2px solid #D7DBE3", marginBottom: 30 }}
          />

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Form.Group className="mb-3" style={{ width: "46%" }}>
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                ເລກທີ່ໃບສັ່ງຊື້
                <span style={{ marginLeft: 1, color: "#FF3939" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={orderData?.orderGroup?.code ?? ""}
                disabled
              />
              <div style={{ height: 10 }} />
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                ສະຖານະອໍເດີ້
                <span style={{ marginLeft: 1, color: "#FF3939" }}>*</span>
              </Form.Label>
              <Form.Control as="select" name="selectStatus" custom>
                <option value="">
                  {convertOrderStatus(orderData?.orderGroup?.status)}
                </option>
              </Form.Control>
              <div style={{ height: 10 }} />
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                ວັນທີ່ສັ່ງຊື້
                <span style={{ marginLeft: 1, color: "#FF3939" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={
                  moment(orderData?.orderGroup?.createdAt).format(
                    "DD/MM/YYYY HH:mm"
                  ) ?? ""
                }
              />
              <div style={{ height: 10 }} />
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                ໝາຍເຫດພາຍໃນ
              </Form.Label>
              <Form.Control
                type="text"
                as="textarea"
                placeholder="ອະທິບາຍ"
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3" style={{ width: "46%" }}>
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                ຊື່ລູກຄ້າ
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="ກະລຸນາປ້ອນ"
                value={orderData?.orderGroup?.userConfirm?.name ?? ""}
              />
              <div style={{ height: 10 }} />
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                ຊື່ Facebook ລູກຄ້າ
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="ກະລຸນາປ້ອນ"
                style={{ background: "#F5F5F5" }}
                value={cfName}
                onChange={(e) => setCfName(e.target.value)}
              />
              <div style={{ height: 10 }} />
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                Facebook ID
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="ກະລຸນາປ້ອນ"
                style={{ background: "#F5F5F5" }}
                value={orderData?.orderGroup?.userConfirm?.user?.fbId ?? ""}
              />
              <div style={{ height: 10 }} />
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                ເບີໂທ
                <span style={{ marginLeft: 1, color: "#FF3939" }}>*</span>
              </Form.Label>
              <div style={{ position: "relative" }}>
                <span
                  style={{
                    position: "absolute",
                    left: "0",
                    top: ".41em",
                    fontSize: 17,
                  }}>
                  020
                </span>

                <Form.Control
                  type="text"
                  placeholder="XXX-XXX-XX"
                  value={phone}
                  // onChange={(e) =>}
                  onChange={(e) => {
                    const _phone = e?.target?.value;

                    // Check if the input is a number and has at most 8 digits
                    if (!/^\d{0,8}$/.test(_phone)) return;
                    setPhone(_phone);
                  }}
                />
              </div>

              <div style={{ height: 10 }} />
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                ຂົນສົ່ງ
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="ຊື່ຂົນສົ່ງ..."
                value={logistic}
                onChange={(e) => setLogistic(e.target.value)}
              />
              <div style={{ height: 10 }} />
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                ທີ່ຢູ່ປາຍທາງ
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="ຕົວຢ່າງ: ຮ່ອມ, ບ້ານ, ເມືອງ, ແຂວງ"
                as="textarea"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </Form.Group>
          </div>
        </div>
      ) : (
        <div style={{ width: "93vw" }}>
          <h4 style={{ fontWeight: "bold" }}>ສ້າງອໍເດີ້</h4>
          <div
            style={{ borderBottom: "2px solid #D7DBE3", marginBottom: 30 }}
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Form.Group className="mb-3" style={{ width: "46%" }}>
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                ຊື່ລູກຄ້າ
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="ກະລຸນາປ້ອນ"
                value={cfName}
                onChange={(e) => setCfName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" style={{ width: "46%" }}>
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                ເບີໂທ
                <span style={{ marginLeft: 1, color: "#FF3939" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="020..."
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </Form.Group>
          </div>

          <div style={{ height: 10 }} />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Form.Group className="mb-3" style={{ width: "46%" }}>
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                ໝາຍເຫດພາຍໃນ
              </Form.Label>
              <Form.Control
                type="text"
                as="textarea"
                placeholder="ອະທິບາຍ"
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3" style={{ width: "46%" }}>
              <Form.Label
                style={{
                  marginBottom: 2,
                  fontWeight: "bold",
                  color: "#5C5C5C",
                }}>
                ທີ່ຢູ່ປາຍທາງ
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="ຕົວຢ່າງ: ຊື່ຂົນສົ່ງ, ບ້ານ, ເມືອງ, ແຂວງ"
                as="textarea"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </Form.Group>
          </div>
        </div>
      )}

      <div style={{ height: 20 }} />
      <Table>
        <thead>
          <tr>
            <th
              style={{
                borderTop: "none",
                borderBottom: "1px solid #C9CFDA",
                width: 80,
              }}>
              #
            </th>
            <th
              style={{
                borderTop: "none",
                borderBottom: "1px solid #C9CFDA",
                width: 280,
              }}>
              ລະຫັດ CF
            </th>
            <th
              style={{
                borderTop: "none",
                borderBottom: "1px solid #C9CFDA",
                width: 350,
              }}>
              ຊື່ສິນຄ້າ
            </th>
            <th
              style={{
                borderTop: "none",
                borderBottom: "1px solid #C9CFDA",
                width: 150,
              }}>
              ຈຳນວນ
            </th>
            <th
              style={{ borderTop: "none", borderBottom: "1px solid #C9CFDA" }}>
              ລາຄາ
            </th>
            <th
              style={{ borderTop: "none", borderBottom: "1px solid #C9CFDA" }}>
              ທັງໝົດ
            </th>
            <th
              style={{
                borderTop: "none",
                borderBottom: "1px solid #C9CFDA",
                width: 50,
              }}></th>
          </tr>
        </thead>
        <tbody>
          {orderList.map((order, index) => (
            <tr key={index}>
              <td
                style={{
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                }}>
                {index + 1}
              </td>
              <td style={{ borderBottom: "none" }}>
                <input
                  style={{ padding: 6, border: "1px solid #C9CFDA" }}
                  value={order?.cfMessage ?? ""}
                />
              </td>
              <td style={{ borderBottom: "none" }}>
                <input
                  style={{ padding: 6, border: "1px solid #C9CFDA" }}
                  value={order?.productName}
                />
              </td>
              <td
                style={{
                  borderBottom: "none",
                  display: "flex",
                  justifyContent: "start",
                }}>
                <Form.Control
                  type="number"
                  name="stockAmount"
                  value={order?.amount}
                  min={1}
                  placeholder="0"
                />
              </td>
              <td style={{ borderBottom: "none" }}>
                <input
                  style={{
                    padding: 6,
                    border: "1px solid #C9CFDA",
                    textAlign: "end",
                  }}
                  value={`₭ ${thousandSeperate(order?.price ?? 0)}`}
                />
              </td>
              <td style={{ borderBottom: "none" }}>
                <input
                  style={{
                    padding: 6,
                    border: "1px solid #C9CFDA",
                    textAlign: "end",
                  }}
                  value={`₭ ${thousandSeperate(order?.totalPrice ?? 0)}`}
                />
              </td>
              <td
                style={{
                  display: "flex",
                  alignItem: "center",
                  border: "none",
                }}>
                <div
                  style={{
                    background: "red",
                    display: "flex",
                    justifyContent: "center",
                    padding: 6,
                  }}
                  onClick={() => _selectOrderIndex(order?.id, index, order)}>
                  <FontAwesomeIcon icon={faTrash} color="white" />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Form.Group className="mb-3" style={{ width: "46%" }}>
          <div
            style={{
              background: "#E8EDF1",
              width: "20%",
              textAlign: "center",
              height: 40,
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 4,
            }}
            onClick={() => setShowOrder(true)}>
            <IoMdAdd style={{ marginRight: 5 }} /> ເພີ່ມລາຍການ
          </div>
        </Form.Group>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Form.Group className="mb-3" style={{ width: "46%" }}>
          {paySlip && (
            <Form.Label
              style={{ marginBottom: 2, fontWeight: "bold", color: "#5C5C5C" }}>
              <div style={{ display: "flex", flexDirection: "row" }}>
                Slip ການຈ່າຍເງິນ
                <a href={imageRender(paySlip)} target="_blank">
                  <div
                    style={{
                      color: "#3c169B",
                      marginLeft: 10,
                      cursor: "pointer",
                    }}>
                    <FontAwesomeIcon icon={faDownload} /> <u>Download</u>
                  </div>
                </a>
              </div>
            </Form.Label>
          )}
          {paySlip && (
            <div style={{ display: "flex", width: "100%" }}>
              <img
                src={imageRender(paySlip)}
                style={{ width: "40%", height: "auto" }}
              />
            </div>
          )}
        </Form.Group>
        <Form.Group className="mb-3" style={{ width: "46%" }}>
          <Form.Label
            style={{ marginBottom: 2, fontWeight: "bold", color: "#5C5C5C" }}>
            ຄ່າສົ່ງ
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="0"
            value={shipPrice}
            onChange={(e) => setShipPrice(e.target.value)}
          />
          <div style={{ height: 30 }} />
          <Form.Label
            style={{
              marginBottom: 2,
              fontWeight: "bold",
              color: "#5C5C5C",
              display: "flex",
              justifyContent: "space-between",
            }}>
            <div>ລວມທັງໝົດ</div>
            <div style={{ display: "flex" }}>
              ຈ່າຍປາຍທາງ
              <Form.Check
                type="switch"
                id="switch1"
                checked={check}
                onChange={() => {
                  setCheck(!check);
                  if (check == true) {
                    setPaymentType("ORIGINAL");
                  } else {
                    setPaymentType("DESTINATION");
                  }
                }}
                style={{ marginLeft: 5 }}
              />
            </div>
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="0"
            value={thousandSeperate(totalAll)}
            style={{ textAlign: "end" }}
          />
        </Form.Group>
      </div>
      <div style={{ height: 10 }} />

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Form.Group className="mb-3" style={{ width: "46%" }}></Form.Group>
        <Form.Group
          className="mb-3"
          style={{ width: "46%", display: "flex", justifyContent: "flex-end" }}>
          <div
            style={{
              background: "#E8EDF1",
              width: "20%",
              height: 35,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 4,
            }}
            onClick={() => history.push(`/orders`)}>
            ຍົກເລີກ
          </div>

          <div style={{ width: "5%" }} />

          <div
            style={{
              background: "#1890FF",
              width: "20%",
              height: 35,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              borderRadius: 4,
            }}
            onClick={() => updateAllGroupField()}>
            ບັນທຶກ
          </div>
        </Form.Group>
      </div>
      <div style={{ height: 20 }} />

      <Modal
        show={showDeleteConfirm}
        onHide={() => setShowDeleteConfirm(false)}>
        <Modal.Header>
          <Modal.Title>ຢືນຢັນການລືບ</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          <Button
            variant="secondary"
            style={{
              background: "#E8EDF1",
              color: "black",
              borderColor: "#E8EDF1",
              marginRight: 10,
            }}
            onClick={() => setShowDeleteConfirm(false)}>
            ຍົກເລີກ
          </Button>
          <Button
            variant="primary"
            style={{
              background: COLOR_APP,
              borderColor: COLOR_APP,
              marginLeft: 10,
            }}
            onClick={handleDelete}>
            ຢືນຢັນ
          </Button>
        </Modal.Body>
      </Modal>

      {/* <Modal show={showAddRow} onHide={() => setShowAddRow(false)}>
        <Modal.Body style={{ textAlign: "center" }}>
          <RiErrorWarningLine size={60} color="yellow" />
          <div style={{ height: 10 }} />
          <div>ກໍານົດຄ່າໃສ່ຕົວເລືອກທີ່ເພີ່ມກ່ອນຫນ້ານີ້ກ່ອນ</div>
        </Modal.Body>
      </Modal> */}

      <Modal show={showOrder} onHide={() => setShowOrder(false)} size="lg">
        <Modal.Header>
          <Modal.Title>ເພີ່ມລາຍການສັ່ງຊື້</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          <div style={{ display: "flex" }}>
            <Form.Group style={{ width: "50%" }}>
              <div style={{ textAlign: "start" }}>ລະຫັດ CF</div>
              <div className="input-group">
                <input
                  type="text"
                  list="listItem"
                  placeholder="ເລືອກສິນຄ້າ"
                  onChange={(e) => onSelectStock(e)}
                  className="form-control form-control-md"
                />
                <datalist id="listItem">
                  {stocksData.length > 0 &&
                    stocksData?.map((item, index) => {
                      return (
                        <option key={index} value={"ລະຫັດ: " + item?.cfMessage}>
                          {"ສິນຄ້າ: " + item?.name}, {"ຈຳນວນ: " + item?.amount},
                          {"ລາຄາ: " + item?.price}
                        </option>
                      );
                    })}
                </datalist>
              </div>
            </Form.Group>

            <div style={{ width: 10 }} />
            <Form.Group style={{ width: "50%" }}>
              <div style={{ textAlign: "start" }}>ຊື່ສິນຄ້າ</div>
              <Form.Control
                type="text"
                placeholder=""
                value={productName}
                onChange={(e) => setProductName(e.target.value)}
              />
            </Form.Group>
          </div>

          <div style={{ display: "flex" }}>
            <Form.Group style={{ width: "50%" }}>
              <div style={{ textAlign: "start" }}>ຈໍານວນ</div>
              <Form.Control
                type="number"
                name="stockAmount"
                onChange={(e) => setAmount(e?.target?.value)}
                value={amount}
                min={0}
                placeholder="0"
              />
            </Form.Group>
            <div style={{ width: 10 }} />
            <Form.Group style={{ width: "50%" }}>
              <div style={{ textAlign: "start" }}>ລາຄາ</div>
              <NumberFormat
                name="price"
                onChange={(e) => setPrice(e?.target?.value)}
                value={price}
                className="form-control"
                placeholder="0"
                thousandSeparator={true}
                prefix={""}
              />
            </Form.Group>
          </div>

          <div style={{ display: "flex" }}>
            <Form.Group className="mb-3" style={{ width: "50%" }}>
              <div style={{ textAlign: "start" }}>ທັງໝົດ</div>
              <NumberFormat
                name="price"
                onChange={(e) => setTotalPrice(e?.target?.value)}
                value={totalPrice}
                className="form-control"
                placeholder="0"
                thousandSeparator={true}
                prefix={""}
              />
            </Form.Group>
          </div>

          <div style={{ height: 30 }} />
          <Button
            variant="secondary"
            style={{
              background: "#E8EDF1",
              color: "black",
              borderColor: "#E8EDF1",
              marginRight: 10,
            }}
            onClick={() => {
              setShowOrder(false);
              setCfCode("");
              setPrice(0);
              setTotalPrice(0);
            }}>
            ຍົກເລີກ
          </Button>
          <Button
            variant="primary"
            style={{
              background: COLOR_APP,
              borderColor: COLOR_APP,
              marginLeft: 10,
            }}
            onClick={() => {
              if (orderData?.orderGroup?.type == "LIVE") {
                _createLiveStock();
              } else if (orderData?.orderGroup?.type == "KEY_IN") {
                _createOrderKeyIn();
              }
              setShowOrder(false);
              setCfCode("");
              setPrice(0);
              setTotalPrice(0);
            }}>
            ບັນທຶກ
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default OrderGroupDetail;
